import React, { useContext } from 'react'
import { Provider as PaymentProvider } from '../contexts/PaymentContext'
import { Provider as FilterPaymentProvider } from '../contexts/FilterPaymentContext'
import { Provider as AccountingBookProvider } from '../contexts/AccountingBookContext'
import { Context as AuthContext } from '../contexts/AuthContext'
import { Route } from 'react-router-dom';
import BookHistoryPage from './BookHistoryPage'
import PaymentsPage from './PaymentsPage'
import AccountingBookSettingPage from './AccountingBookSettingPage'
import AccountingBookEditPage from './AccountingBookEditPage'
import AccountingBookDefaultUsersPage from './AccountingBookDefaultUsersPage'
import RemittanceInfoPage from './RemittanceInfoPage'
import AccountingBooksPage from './AccountingBooksPage'
import GroupMembersPage from './GroupMembersPage/GroupMembersPage'
import DeletedAccountingBooksPage from './DeletedAccountingBooksPage/DeletedAccountingBooksPage'
import MemberPaymentsPage from './MemberPaymentsPage'
import DesktopShell from '../components/Desktop/DesktopShell'
import { useLiff, useIsDesktop } from '../hooks'
import {
  MagicRedirect,
  CurrentRedirect,
  PaymentEditPage,
  AccountingBookCurrencyPage,
  AccountingBookCreationPage,
  PaymentPaidBackPage,
  PaymentCreationPage,
  PaymentFilterPage,
  AccountingBookSummaryPage,
  OverviewPage,
} from './index'

const NavigationPage = (props) => {
  const { setLogin } = useContext(AuthContext)
  /* eslint-disable no-unused-vars */
  const [isLoggedIn] = useLiff(setLogin)
  const isDesktop = useIsDesktop()

  var ver = "v1"

  // On desktop the whole route tree is wrapped in the two-pane shell; on
  // mobile (incl. the LIFF webview) Wrapper is a transparent Fragment so the
  // existing experience is byte-for-byte unchanged.
  const Wrapper = isDesktop ? DesktopShell : React.Fragment

  return(
    <PaymentProvider>
      <Wrapper>
        <Route exact path="/liff_entry"> </Route>
        <Route exact path="/liff_entry/groups/:group_id/accounting_books">
          <AccountingBooksPage/>
        </Route>
        <Route exact path={`/liff_entry/${ver}/groups/:group_id/accounting_books`}>
          <AccountingBooksPage/>
        </Route>
        <Route exact path="/liff_entry/groups/:group_id/accounting_books/deleted">
          <DeletedAccountingBooksPage/>
        </Route>
        <Route exact path={`/liff_entry/${ver}/groups/:group_id/accounting_books/deleted`}>
          <DeletedAccountingBooksPage/>
        </Route>
        <Route exact path="/liff_entry/groups/:group_id/accounting_books_2">
          <AccountingBooksPage/>
        </Route>
        <Route exact path="/liff_entry/groups/:group_id/members">
          <GroupMembersPage/>
        </Route>
        <Route exact path={`/liff_entry/${ver}/groups/:group_id/members`}>
          <GroupMembersPage/>
        </Route>
        <Route exact path="/liff_entry/mg">
          <MagicRedirect/>
        </Route>
        <Route exact path={`/liff_entry/${ver}/mg`}>
          <MagicRedirect/>
        </Route>
        <AccountingBookProvider>
          <Route exact path="/liff_entry/groups/:group_id/current_payments">
            <CurrentRedirect page="current_payments"/>
          </Route>
          <Route exact path="/liff_entry/groups/:group_id/current_overview">
            <CurrentRedirect page="current_overview"/>
          </Route>
          <Route exact path={`/liff_entry/${ver}/groups/:group_id/current_overview`}>
            <CurrentRedirect page="current_overview"/>
          </Route>
          <Route exact path="/liff_entry/groups/:group_id/accounting_books/:accounting_book_id/overview">
            <OverviewPage/>
          </Route>
          <Route exact path={`/liff_entry/${ver}/groups/:group_id/accounting_books/:accounting_book_id/overview`}>
            <OverviewPage/>
          </Route>
          <Route exact path={`/liff_entry/${ver}/groups/:group_id/current_payments`}>
            <CurrentRedirect page="current_payments"/>
          </Route>
          <Route exact path="/liff_entry/groups/:group_id/current_payments_2">
            <CurrentRedirect page="current_payments"/>
          </Route>
          <Route exact path="/liff_entry/groups/:group_id/current_summary">
            <CurrentRedirect page="current_summary"/>
          </Route>
          <Route exact path={`/liff_entry/${ver}/groups/:group_id/current_summary`}>
            <CurrentRedirect page="current_summary"/>
          </Route>
          <Route exact path="/liff_entry/groups/:group_id/current_summary_2">
            <CurrentRedirect page="current_summary"/>
          </Route>
          <Route exact path="/liff_entry/groups/:group_id/current_new_payment">
            <CurrentRedirect page="current_new_payment"/>
          </Route>
          <Route exact path={`/liff_entry/${ver}/groups/:group_id/current_new_payment`}>
            <CurrentRedirect page="current_new_payment"/>
          </Route>
          <Route exact path="/liff_entry/groups/:group_id/current_new_payment_2">
            <CurrentRedirect page="current_new_payment"/>
          </Route>
          <Route exact path="/liff_entry/groups/:group_id/accounting_books/:accounting_book_id/payments/new">
            <PaymentCreationPage />
          </Route>
          <Route exact path={`/liff_entry/${ver}/groups/:group_id/accounting_books/:accounting_book_id/payments/new`}>
            <PaymentCreationPage />
          </Route>
          <Route exact path="/liff_entry/groups/:group_id/accounting_books/:accounting_book_id/payments/paid_back">
            <PaymentPaidBackPage />
          </Route>
          <Route exact path={`/liff_entry/${ver}/groups/:group_id/accounting_books/:accounting_book_id/payments/paid_back`}>
            <PaymentPaidBackPage />
          </Route>
          <Route exact path="/liff_entry/groups/:group_id/accounting_books/new">
            <AccountingBookCreationPage />
          </Route>
          <Route exact path={`/liff_entry/${ver}/groups/:group_id/accounting_books/new`}>
            <AccountingBookCreationPage />
          </Route>
          <Route exact path="/liff_entry/groups/:group_id/accounting_books/:accounting_book_id/payments/:payment_id/edit">
            <PaymentEditPage />
          </Route>
          <Route exact path={`/liff_entry/${ver}/groups/:group_id/accounting_books/:accounting_book_id/payments/:payment_id/edit`}>
            <PaymentEditPage />
          </Route>
          <Route exact path="/liff_entry/groups/:group_id/accounting_books/:accounting_book_id/payments/summary">
            <AccountingBookSummaryPage/>
          </Route>
          <Route exact path="/liff_entry/groups/:group_id/accounting_books/:accounting_book_id/members/:member_id/payments">
            <MemberPaymentsPage/>
          </Route>
          <FilterPaymentProvider>
            <Route exact path={`/liff_entry/${ver}/groups/:group_id/accounting_books/:accounting_book_id/payments/summary`}>
              <AccountingBookSummaryPage/>
            </Route>
            <Route exact path="/liff_entry/groups/:group_id/accounting_books/:accounting_book_id/payments/index">
              <PaymentsPage index={0}/>
            </Route>
            <Route exact path={`/liff_entry/${ver}/groups/:group_id/accounting_books/:accounting_book_id/payments/index`}>
              <PaymentsPage index={0}/>
            </Route>
            <Route exact path="/liff_entry/groups/:group_id/accounting_books/:accounting_book_id/payments/filter">
              <PaymentFilterPage />
            </Route>
            </FilterPaymentProvider>
          <Route exact path="/liff_entry/groups/:group_id/accounting_books/:accounting_book_id/edit/index">
            <AccountingBookEditPage />
          </Route>
          <Route exact path={`/liff_entry/${ver}/groups/:group_id/accounting_books/:accounting_book_id/edit/index`}>
            <AccountingBookEditPage />
          </Route>
          <Route exact path="/liff_entry/groups/:group_id/accounting_books/:accounting_book_id/currency">
            <AccountingBookCurrencyPage />
          </Route>
          <Route exact path={`/liff_entry/${ver}/groups/:group_id/accounting_books/:accounting_book_id/currency`}>
            <AccountingBookCurrencyPage />
          </Route>
          <Route exact path="/liff_entry/groups/:group_id/accounting_books/:accounting_book_id/settings">
            <AccountingBookSettingPage />
          </Route>
          <Route exact path={`/liff_entry/${ver}/groups/:group_id/accounting_books/:accounting_book_id/settings`}>
            <AccountingBookSettingPage />
          </Route>
          <Route exact path="/liff_entry/groups/:group_id/accounting_books/:accounting_book_id/default_users">
            <AccountingBookDefaultUsersPage />
          </Route>
          <Route exact path={`/liff_entry/${ver}/groups/:group_id/accounting_books/:accounting_book_id/default_users`}>
            <AccountingBookDefaultUsersPage />
          </Route>
          <Route exact path="/liff_entry/groups/:group_id/accounting_books/:accounting_book_id/remittance_info">
            <RemittanceInfoPage />
          </Route>
          <Route exact path={`/liff_entry/${ver}/groups/:group_id/accounting_books/:accounting_book_id/remittance_info`}>
            <RemittanceInfoPage />
          </Route>
          <Route exact path="/liff_entry/groups/:group_id/accounting_books/:accounting_book_id/log_messages">
            <BookHistoryPage/>
          </Route>
          <Route exact path={`/liff_entry/${ver}/groups/:group_id/accounting_books/:accounting_book_id/log_messages`}>
            <BookHistoryPage/>
          </Route>
        </AccountingBookProvider>
      </Wrapper>
    </PaymentProvider>
  )
}

export default NavigationPage

